import { toDigits } from './toDigits';

const MONTH_END = 2;
const DAY_END = 4;
const DATE_OF_BIRTH_DIGITS = 8;

export const toDOBString = (value?: string | number | null): string => {
  const digits = toDigits(value).slice(0, DATE_OF_BIRTH_DIGITS);

  if (digits.length === 0) {
    return '';
  }

  if (digits.length <= MONTH_END) {
    return digits;
  }

  if (digits.length <= DAY_END) {
    return `${digits.slice(0, MONTH_END)}/${digits.slice(MONTH_END)}`;
  }

  return `${digits.slice(0, MONTH_END)}/${digits.slice(
    MONTH_END,
    DAY_END,
  )}/${digits.slice(DAY_END)}`;
};
